import type { LabelHTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/cn';

export function Label({ className, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-xs font-bold text-ink2', className)} {...rest} />;
}

export interface FieldProps {
  label?: ReactNode;
  hint?: ReactNode;
  error?: string | undefined;
  htmlFor?: string | undefined;
  wide?: boolean | undefined;
  className?: string | undefined;
  children: ReactNode;
}

/** Label + control + hint/error; the error is announced inline (doc 08: inline validation). */
export function Field({ label, hint, error, htmlFor, wide, className, children }: FieldProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1', wide && 'w', className)}>
      {label ? <Label htmlFor={htmlFor}>{label}</Label> : null}
      {children}
      {error ? (
        <span role="alert" className="text-[11px] font-semibold text-bad">
          {error}
        </span>
      ) : hint ? (
        <span className="text-[11px] text-ink3">{hint}</span>
      ) : null}
    </div>
  );
}
